import api from "../utils/axios";

export const getUserProfile = async () => {
  try {
    const response = await api.get("/user/profile");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.put("/user/profile", profileData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.post("/user/change-password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updatePreferences = async (data) => {
  try {
    const response = await api.put("/users/preferences", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateCompanyInfo = async (companyInfo) => {
  try {
    const response = await api.post("/user/company-info", companyInfo);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompany = async (companyId, data) => {
  try {
    const response = await api.put(`/user/companies/${companyId}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const uploadCompanyLogo = async (companyId, file) => {
  try {
    const formData = new FormData();
    formData.append("logo", file);
    const response = await api.post(`/user/companies/${companyId}/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateOrganization = async (data) => {
  try {
    const response = await api.put("/user/organization", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getUserCompanies = async () => {
  try {
    const response = await api.get("/user/companies");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getPlans = async () => {
  try {
    const response = await api.get("/plans");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getMembers = async () => {
  try {
    const response = await api.get("/user/members/list");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addMember = async (memberData) => {
  try {
    const response = await api.post("/user/members/add", memberData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateMember = async (memberId, memberData) => {
  try {
    const response = await api.post(
      `/user/members/update/${memberId}`,
      memberData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const removeMember = async (memberId) => {
  try {
    const response = await api.delete(`/user/members/remove/${memberId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSession = async (data) => {
  try {
    const response = await api.post("/stripe/create-checkout-session", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const verifyPayment = async (sessionId) => {
  try {
    const response = await api.get(`/stripe/checkout-session/${sessionId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getPortalLink = async () => {
  try {
    const response = await api.post("/stripe/create-portal-session");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSubscription = async () => {
  try {
    const response = await api.get("/stripe/subscription");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSubscriptionDetails = async () => {
  try {
    const response = await api.get("/stripe/subscription-details");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSubscriptionActivities = async (page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `/stripe/activities?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const upgradePlan = async (planId, subscriptionType) => {
  try {
    const response = await api.post("/stripe/upgrade-plan", {
      planId,
      subscriptionType,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await api.post("/stripe/cancel-subscription");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const reactivateSubscription = async () => {
  try {
    const response = await api.post("/stripe/reactivate-subscription");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Invite Management APIs
export const getInvitedMembers = async (status = null) => {
  try {
    const params = status ? { status } : {};
    const response = await api.get("/user/invites/list", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const sendInvitation = async (inviteData) => {
  try {
    const response = await api.post("/user/invites/send", inviteData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const revokeInvitation = async (inviteId) => {
  try {
    const response = await api.post(`/user/invites/revoke/${inviteId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInviteDetails = async (token) => {
  try {
    const response = await api.get(`/user/invites/details/${token}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const acceptInvitation = async (token, data) => {
  try {
    const response = await api.post(`/user/invites/accept/${token}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resendInvitation = async (inviteId, inviteData = {}) => {
  try {
    const response = await api.post(
      `/user/invites/resend/${inviteId}`,
      inviteData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const uploadFile = async (uploadData) => {
  try {
    const response = await api.post("/user/upload", uploadData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSelfSignedDocuments = async () => {
  try {
    const response = await api.get("/user/self-signed-documents");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSelfSignedDocument = async (documentId) => {
  try {
    const response = await api.delete(
      `/user/self-signed-documents/${documentId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
